import { alpha, createTheme } from '@mui/material';

const baseTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#b3daff',
    },
    info: {
      main: '#2a2a2a',
      contrastText: '#ddd',
    },
  },
});

const chipCommon = {
  fontSize: '10px',
  fontWeight: 700,
  letterSpacing: '0.1em',
  padding: '4px 12px',
  minHeight: 'auto',
  height: 'auto',
  borderRadius: 0,
};

const theme = createTheme(baseTheme, {
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          ...chipCommon,
          backgroundColor: alpha(baseTheme.palette.primary.main, 0.1),
          border: `1px solid ${alpha(baseTheme.palette.primary.main, 0.2)}`,
          color: baseTheme.palette.primary.main,
        },
        colorPrimary: {
          backgroundColor: alpha(baseTheme.palette.primary.main, 0.1),
          border: `1px solid ${alpha(baseTheme.palette.primary.main, 0.2)}`,
          color: baseTheme.palette.primary.main,
        },
        colorInfo: {
          backgroundColor: alpha(baseTheme.palette.info.main, 0.1),
          border: `1px solid ${alpha(baseTheme.palette.info.main, 0.2)}`,
          color: baseTheme.palette.info.main,
        },
        colorSecondary: {
          backgroundColor: alpha(baseTheme.palette.secondary.main, 0.1),
          border: `1px solid ${alpha(baseTheme.palette.secondary.main, 0.2)}`,
          color: baseTheme.palette.secondary.main,
        },
        colorSuccess: {
          backgroundColor: alpha(baseTheme.palette.success.main, 0.1),
          border: `1px solid ${alpha(baseTheme.palette.success.main, 0.2)}`,
          color: baseTheme.palette.success.main,
        },
        colorWarning: {
          backgroundColor: alpha(baseTheme.palette.warning.main, 0.1),
          border: `1px solid ${alpha(baseTheme.palette.warning.main, 0.2)}`,
          color: baseTheme.palette.warning.main,
        },
        colorError: {
          backgroundColor: alpha(baseTheme.palette.error.main, 0.1),
          border: `1px solid ${alpha(baseTheme.palette.error.main, 0.2)}`,
          color: baseTheme.palette.error.main,
        },
        label: {
          padding: 0,
        },
      },
    },
  },
});

export default theme;
